<template>
  <div>
    <transition-group name="fade">
      <div v-if="showAnimation" :key="0" class="animation-contents">
        <img :src="imgSrc" class="animation-image" />
      </div>
    </transition-group>
    <div>
      <b-modal
        id="birthday-modal"
        v-model="modalShow"
        centered
        hide-header
        hide-footer
        ok-disabled
        cancel-disabled
      >
        <div class="d-block text-center modal-container">
          <div class="content-subject">{{ $t('present.arrivedPresent') }}</div>
          <div class="content-desc">{{ $t('present.cannotCancelOperation') }}</div>
          <div>
            <b-row class="buttons">
              <b-col>
                <div block class="buttons-button-cancel" @click="handleClose">
                  {{ $t('present.notReceive') }}
                </div>
              </b-col>
              <b-col>
                <div block class="buttons-button-recieve" @click="receivePresent">
                  {{ $t('present.receive') }}
                </div>
              </b-col>
            </b-row>
          </div>
        </div>
      </b-modal>
    </div>
  </div>
</template>
<script>
import config from '@/config/config'
import * as api from '@/api'
import { mapGetters, mapActions } from 'vuex'
export default {
  data() {
    return {
      contents: [
        [
          `${config.domain}/assets/image/birthday/pattern_1/birthday_1.png`,
          `${config.domain}/assets/image/birthday/pattern_1/birthday_2.png`,
          `${config.domain}/assets/image/birthday/pattern_1/birthday_3.png`,
          // `${config.domain}/assets/image/birthday/pattern_1/birthday_4.png`,
          // `${config.domain}/assets/image/birthday/pattern_1/birthday_5.png`
        ],
      ],
      animation: null,
      showAnimation: false,
      isDone: false,
      imgSrc: '',
      timerCount: 0,
    }
  },
  computed: {
    ...mapGetters({
      hasBirthdayEvent: 'seat/getHasBirthdayEvent',
      isShowingTutorialModal: 'modal/isShowingBirthMonthEvent',
      shopId: 'seat/getShopId',
      seatNo: 'seat/getSeatNo',
    }),
    modalShow: {
      get() {
        return this.isShowingTutorialModal
      },
      set(value) {
        this.setShowingModal(value)
      },
    },
  },
  watch: {
    hasBirthdayEvent() {
      if (this.isDone) return
      this.isDone = true
      if (this.hasBirthdayEvent) this.setShowingModal(true)
    },
  },
  methods: {
    ...mapActions({
      setShowingModal: 'modal/setShowingBirthMonthEventModal',
    }),
    handleClose() {
      this.setShowingModal(false)
    },
    // 受け取る押下時
    receivePresent() {
      this.showAnimation = true
      // モーダル閉じる
      this.setShowingModal(false)

      const _this = this
      const contentsPattern = 0
      _this.animation = setInterval(() => {
        // 画像を表示
        this.imgSrc = _this.contents[contentsPattern][this.timerCount]
        this.timerCount++
        if (_this.timerCount > _this.contents[contentsPattern].length) {
          // アニメーション終了
          clearInterval(this.animation)
          this.showAnimation = false
          // 動画再生apiを実行
          this.playVideo()
        }
      }, 1000)
    },
    // タブレット端末で動画を再生
    playVideo() {
      // APIの実行
      api.playBirthdayVideo(this.shopId, this.seatNo)
    },
  },
}
</script>
<style lang="scss" scoped>
.animation-contents {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: 9999;
  background-color: #fff;
}
.animation-image {
  max-height: 100%;
}
.modal-container {
  padding-top: 8px;
}
.content {
  color: #222222;
  &-subject {
    font-size: 18px;
    font-weight: bold;
    @media screen and (max-width: 375px) {
      font-size: 0.95rem;
    }
  }
  &-desc {
    padding: 20px 0;
    font-size: 14px;
  }
}
.col {
  padding-left: 4px;
  padding-right: 4px;
}
.buttons {
  padding: 10px 0;
  margin: 10px 0 0;
  width: 100%;
  height: 38px;
  line-height: 38px;
  border-radius: 5px;
  font-size: 1rem;
  font-weight: bold;
  padding: 0px 0 45px 0px;
  // for iphone5/SE
  @media screen and (max-width: 375px) {
    font-size: 0.85rem;
  }
  &-button {
    &-recieve {
      border-radius: 5px;
      color: white;
      background-color: #d21b24;
      border-bottom: 2px solid #96131a;
    }
    &-cancel {
      border-radius: 5px;
      color: white;
      background-color: #666;
      border-bottom: 2px solid #333;
    }
  }
}
::v-deep {
  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 1s;
  }
  .fade-enter,
  .fade-leave-to {
    opacity: 0;
  }
}
</style>
